var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "omnichannel__sections" },
    _vm._l(_vm.services, function (service, index) {
      return _c(
        "ul",
        { key: index, staticClass: "omnichannel__section" },
        [
          service.title
            ? _c(
                "li",
                { staticClass: "section__title" },
                [
                  _c("rb-lazy-icon", {
                    attrs: { icon: service.icon, text: service.icon },
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.translation("header.omnichannel." + service.title)
                      ) +
                      "\n    "
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(service.options, function (option, optIndex) {
            return _c(
              "li",
              {
                key: optIndex,
                staticClass: "section__item",
                class: { "section__item--highlighted": option.isHighlighted },
              },
              [
                _c("a", {
                  attrs: {
                    href: option.url,
                    "data-element-id":
                      "X_X_MainNav_Services_" + option.analytics,
                    "data-description": option.analytics,
                  },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.translation("header.omnichannel." + option.title)
                    ),
                  },
                }),
              ]
            )
          }),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }